module.exports = __webpack_public_path__ + "assets/chevron-right-gray-121b0d4410b16026ad265d55b81bce7f.svg";